//@ts-nocheck
import { Box, VStack } from "@chakra-ui/react";
import { IRootStore } from "../stores";
import TutorSubjectsPage from "../tutor-revamp/Subject";
import { SubjectPrompt } from "../tutor-revamp/SubjectPrompt";
import React from "react";
import { observer } from "mobx-react-lite";
import SubjectCreationPage from "../tutor-application/pages/SubjectCreationPage";

type Props = {
  store: IRootStore;
  displayPrompt?: boolean;
  generateDescription: (p) => any;
  isLiteTutor?: boolean;
};

function SubjectsPage({
  store,
  displayPrompt = true,
  generateDescription,
  isLiteTutor,
}: Props) {
  const { educations, workHistories } = store.educationWorkHistory.formValues;

  const incompleteSubjects = store.subject.tutorSubjects.filter((subject) =>
    ["not-started", "in-progress"].includes(subject.status)
  );
  const cantAddMoreSubjects = !store.subject.canAddMoreSubjects;

  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <VStack justifyContent="stretch" alignItems="stretch" spacing={[6, 8]}>
        {displayPrompt && (
          <SubjectPrompt
            {...{
              cantAddMoreSubjects,
              incompleteSubjects,
            }}
          />
        )}
        <SubjectCreationPage
          store={store}
          onSubmit={store.subject.saveTutorSelectedSubjects}
          canEditSubject={false}
          generateDescription={generateDescription}
          isLiteTutor={isLiteTutor}
        />
        {/* <TutorSubjectsPage
          store={store.subject}
          showWelcomeModal={false}
          onSubmitSubjects={() => {}}
          educationAndWorkHistoryData={{
            education: educations,
            workHistory: workHistories,
          }}
        /> */}
      </VStack>
    </Box>
  );
}

export default observer(SubjectsPage);
